import { useNavigate } from 'react-router-dom';
import { useConnect } from '../web3/useConnect.js';
import { MagneticButton } from '../components/MagneticButton.js';
export function Connect() {
  const navigate = useNavigate(); const wallet = useConnect();
  return <section className="mx-auto w-full max-w-md px-5 py-10 text-center sm:py-16">
    <span className="kicker justify-center">Welcome to Gilding</span>
    <h1 className="mt-4 font-display text-[2rem] leading-tight tracking-tight sm:text-[2.5rem]">Your wallet.<br/><span className="italic text-ink-soft">Your way in.</span></h1>
    <div className="theme-dark gild-plate relative mt-8 overflow-hidden rounded-2xl px-6 py-7 text-ink sm:px-8">
      <MagneticButton variant="gold-ghost" className="w-full justify-center" busy={wallet.connecting} disabled={wallet.connecting} onClick={async()=>{const result=await wallet.connect();if(result.ok)navigate(result.holder?'/dashboard':'/early-access');}}><span>Connect Wallet</span><span aria-hidden="true">→</span></MagneticButton>
      <p className="mt-3 font-mono text-caption text-ink-subtle">Sign-In With Ethereum · Whacky Whales holders</p>
      <p className="mt-5 border-t border-hairline pt-5 font-display text-caption italic text-ink-subtle">A signature to enter. No gas, no transaction.</p>
      {wallet.error && <p role="status" className="mt-5 font-display text-caption">{wallet.error}</p>}
    </div>
  </section>;
}
